import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { tipoRegraFilterLabel } from '../../../utils';

export const useTipoRegraFilter = () => {
  const getTipoRegraData = async () => {
    const res = await service.getTiposRegraList();

    if (res.status === 200) {
      const list = res.data.map(item => ({ label: tipoRegraFilterLabel[item], value: item }));
      return list;
    }

    return [];
  };

  const { data, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: ['tipo-regra'],
    queryFn: getTipoRegraData,
    retry: false,
  });

  return {
    tipoRegraData: data,
    isError,
    isSuccess,
    refetchTipoRegra: refetch,
  };
};
